export default __webpack_public_path__ + "static/media/LFacebook.92dd3d76.svg";